import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  FieldArray,
  reduxForm,
  stopSubmit,
  formValueSelector,
  getFormValues,
} from "redux-form";
import {
  Form,
  FormGroup,
  Button,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import FileUpload from "../../system/fields/FileUpload";
import List from "../../system/fields/List";
import * as validations from "../../system/utils/Validation";

import LegsWrapper from "./components/Legs";
import DatesWrapper from "./components/Dates";
import SelectDropdown from "../../system/fields/SelectDropdown";
import Wysiwyg from "../../system/fields/Wysiwyg";
import Switch from "../../system/fields/Switch";

import { getOverview } from "../../store/overview";
import { filterString } from "../../system/containers/Table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import ReviewsTable from "./components/ReviewsTable";

class renderDates extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    dateType:
      this.props.day_dates !== undefined && this.props.day_dates.length > 0
        ? "CSV"
        : this.props.fields !== undefined && this.props.fields.length > 0
        ? "DateRange"
        : null,
  };

  render() {
    const { props } = this;
    const {
      day_dates,
      fields,
      meta: { touched, error },
      airports,
    } = props;

    if (this.props.day_dates !== undefined && this.props.day_dates.length > 0) {
      return (
        <div className="repeater-container">
          {day_dates !== undefined && day_dates.length === 0 && (
            <select
              className={"date-type-select"}
              onChange={(e) =>
                this.setState({
                  dateType: e.target.value,
                })
              }
            >
              <option value={null} selected disabled>
                Please Select An Option
              </option>
              <option value={"CSV"}>CSV Upload</option>
              <option value={"DateRange"}>Date Range</option>
              <option value={"SingleMonth"}>Single Month</option>
            </select>
          )}
          <Field
            name="dates_csv"
            component={FileUpload}
            csv={true}
            multiple={false}
            files={true}
            images={false}
            type="text"
            className="form-control"
          />
          {day_dates !== undefined && (
            <div className={"add-button top"}>
              <p className="instruction">
                {day_dates.length} Date{day_dates.length === 1 ? "" : "s"} added
                from uploaded .CSV files
              </p>
            </div>
          )}
        </div>
      );
    }
    if (this.state.dateType === null) {
      return (
        <div className={"repeater-container"}>
          {JSON.stringify(this.state.dateType)}
          <select
            className={"date-type-select"}
            onChange={(e) =>
              this.setState({
                dateType: e.target.value,
              })
            }
          >
            <option value={null} selected disabled>
              Please Select An Option
            </option>
            <option value={"CSV"}>CSV Upload</option>
            <option value={"DateRange"}>Date Range</option>
            <option value={"SingleMonth"}>Single Month</option>
          </select>
        </div>
      );
    }
    if (this.state.dateType === "CSV") {
      return (
        <div className="repeater-container">
          {day_dates !== undefined && day_dates.length === 0 && (
            <select
              className={"date-type-select"}
              onChange={(e) =>
                this.setState({
                  dateType: e.target.value,
                })
              }
            >
              <option value={null} selected disabled>
                Please Select An Option
              </option>
              <option value={"CSV"}>CSV Upload</option>
              <option value={"DateRange"}>Date Range</option>
              <option value={"SingleMonth"}>Single Month</option>
            </select>
          )}
          <Field
            name="dates_csv"
            component={FileUpload}
            csv={true}
            multiple={false}
            files={true}
            images={false}
            type="text"
            className="form-control"
          />
          {day_dates !== undefined && (
            <div className={"add-button top"}>
              <p className="instruction">
                {day_dates.length} Date{day_dates.length === 1 ? "" : "s"} added
                from uploaded .CSV files
              </p>
            </div>
          )}
        </div>
      );
    }
    if (this.state.dateType === "SingleMonth") {
      return (
        <div className="repeater-container">
          {day_dates !== undefined && day_dates.length === 0 && (
            <select
              className={"date-type-select"}
              onChange={(e) =>
                this.setState({
                  dateType: e.target.value,
                })
              }
            >
              <option value={null} selected disabled>
                Please Select An Option
              </option>
              <option value={"CSV"}>CSV Upload</option>
              <option value={"DateRange"}>Date Range</option>
              <option value={"SingleMonth"}>Single Month</option>
            </select>
          )}
          {fields.map((date, index) => {
            return (
              <DatesWrapper
                fields={fields}
                date={date}
                index={index}
                key={index}
                airports={airports}
                // singleMonth={true}
                dispatch={this.props.dispatch}
                dateType={"month"}
              ></DatesWrapper>
            );
          })}
          <div className="add-button top">
            {/* <Button type="button" onClick={() => fields.push({ airport: "" })}> */}
            <Button type="button" onClick={() => fields.push({})}>
              Add Date
            </Button>
            <Button
              type="button"
              color="danger"
              className="float-right"
              onClick={() => fields.removeAll()}
            >
              Clear Dates
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="repeater-container">
        {fields !== undefined && fields.length === 0 && (
          <select
            className={"date-type-select"}
            onChange={(e) =>
              this.setState({
                dateType: e.target.value,
              })
            }
          >
            <option value={null} selected disabled>
              Please Select An Option
            </option>
            <option value={"CSV"}>CSV Upload</option>
            <option value={"DateRange"}>Date Range</option>
            <option value={"SingleMonth"}>Single Month</option>
          </select>
        )}
        <div className="add-button top">
          <Button type="button" onClick={() => fields.push({ airport: {} })}>
            Add Date
          </Button>
          <Button
            type="button"
            color="danger"
            className="float-right"
            onClick={() => fields.removeAll()}
          >
            Clear Dates
          </Button>
        </div>

        {fields.map((date, index) => {
          return (
            <DatesWrapper
              date={date}
              fields={fields}
              index={index}
              key={index}
              airports={airports}
              dispatch={this.props.dispatch}
              dateType={"range"}
            />
          );
        })}
      </div>
    );
  }
}
const renderLegs = ({ fields, meta: { touched, error } }) => (
  <div className="repeater-container pb-5 mb-5">
    {fields.map((leg, index) => (
      <LegsWrapper leg={leg} fields={fields} index={index} key={index} />
    ))}

    <div className="add-button bottom">
      <Button type="button" onClick={() => fields.push({ leg_type: "" })}>
        Add Leg
      </Button>
    </div>
  </div>
);

class EditForm extends Component {
  state = {
    activeTab: 1,
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount() {
    this.props.dispatch(getOverview());
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <section className="edit-form">
        <Form onSubmit={handleSubmit}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 1 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(1);
                }}
              >
                Basic Info
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 2 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(2);
                }}
              >
                Legs
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={this.state.activeTab === 3 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(3);
                }}
              >
                Dates
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 4 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(4);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
          </Nav>
          <section className="form-section">
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId={1}>
                <div className="row">
                  <FormGroup className="col-12 col-sm-6">
                    <Label>Deal Status</Label>
                    <Field
                      name="deal_status"
                      component={SelectDropdown}
                      labelKey="name"
                      valueKey="id"
                      options={this.props.dealStatuses}
                      validate={validations.required}
                      autoFocus={true}
                    />
                  </FormGroup>
                </div>
                <div className="row">
                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="email">Deal Name</Label>
                    <Field
                      name="name"
                      component={TextInput}
                      placeholder="Deal Name"
                      type="text"
                      validate={validations.required}
                    />
                  </FormGroup>

                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="email">Sub Title</Label>
                    <Field
                      name="sub-title"
                      component={TextInput}
                      placeholder="Sub Title"
                      type="text"
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12 col-sm-6">
                    <Label>Tags</Label>
                    <Field
                      name="deal_types"
                      component={SelectDropdown}
                      options={this.props.dealTypes}
                      type="text"
                      labelKey={"name"}
                      valueKey={"id"}
                      validate={validations.required}
                      multi
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-sm-6">
                    <Label>Bookable Online</Label>
                    <Field name="book_online" component={Switch} type="text" />
                  </FormGroup>
                  <FormGroup className="col-12 col-sm-6">
                    <Label>Peace Of Mind</Label>
                    <Field
                      name="peace_of_mind"
                      component={Switch}
                      type="text"
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="email">Deal Duration</Label>
                    <Field
                      name="duration"
                      component={TextInput}
                      placeholder="Deal Duration"
                      type="number"
                      validate={validations.required}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="email">Price From</Label>
                    <Field
                      name="price_from"
                      component={TextInput}
                      placeholder="Price From"
                      type="text"
                      validate={validations.required}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="deposit">Deposit</Label>
                    <Field
                      name="deposit"
                      component={TextInput}
                      placeholder="0"
                      type="number"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label htmlFor="email">Hero Image</Label>
                    <p className="instruction">
                      Images must be 1920 x 1080 or bigger in the same aspect
                      ratio
                    </p>
                    <Field
                      name="banner_image"
                      component={FileUpload}
                      multiple={false}
                      files={false}
                      images={true}
                      type="text"
                      className="form-control"
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label htmlFor="email">Summary</Label>
                    <Field
                      name="summary"
                      component={Wysiwyg}
                      placeholder="Fine Print"
                      type="text"
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label htmlFor="email">Fine Print</Label>
                    <Field
                      name="fine_print"
                      component={Wysiwyg}
                      placeholder="Fine Print"
                      type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label htmlFor="email">Trip Advisor Script</Label>
                    <Field
                      name="trip_advisor_script"
                      component={TextInput}
                      placeholder="Trip Advisor Script"
                      type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label htmlFor="email">Redirect URL</Label>
                    <Field
                      name="redirect_url"
                      component={TextInput}
                      placeholder="Redirection URL"
                      type="text"
                    />
                  </FormGroup>
                </div>
              </TabPane>

              <TabPane tabId={2}>
                <FieldArray name="legs" component={renderLegs} />
              </TabPane>

              <TabPane tabId={3}>
                <FieldArray
                  name="month_dates"
                  day_dates={this.props.day_dates}
                  component={renderDates}
                  dateType={this.props.dateType}
                  dispatch={this.props.dispatch}
                  airports={this.props.airports}
                  disableAddNewDate={this.props.disableAddNewDate}
                  addNewDate={this.props.addNewDate}
                />
              </TabPane>
              <TabPane tabId={4}>
                <ReviewsTable
                  data={this.props.reviews}
                  dispatch={this.props.dispatch}
                  formValues={this.props.formValues}
                  initialValues={this.props.initialValues}
                  formType="DealForm"
                />
              </TabPane>
            </TabContent>
          </section>
        </Form>

        {this.props.submitFailed && (
          <div className="error-container">
            <Alert color="danger">
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: "DealForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("DealForm"));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const selector = formValueSelector("DealForm");

const mapStateToProps = (state) => {
  return {
    dealTypes: state.overview.dealTypes,
    airports: state.overview.airports,
    dealStatuses: state.overview.dealStatuses,
    reviews: state.overview.reviews,
    day_dates: selector(state, "day_dates"),
    formValues: getFormValues("DealForm")(state),
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Deals/Form.jsx